module.exports = __webpack_public_path__ + "img/icon-activity.626f06f7.svg";